import './lib/i18n';
import * as Sentry from '@sentry/react';
import { initAnalytics } from './hooks/useAnalytics';
import { StrictMode, Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { logError } from './lib/error-logger';
import { initServiceWorkerAutoReload } from './lib/sw-update';

// Initialize Sentry — only when DSN is configured (no-op in local dev without it)
const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.2,
    environment: import.meta.env.MODE,
  });
}

// Initialize PostHog — no-op if VITE_POSTHOG_API_KEY is not set
initAnalytics();

// Register the caching service worker and reload the page once when a newly
// deployed SW takes control, so the app comes back up on the fresh precache
// instead of 404-ing lazy chunks against a stale one. See lib/sw-update.ts.
initServiceWorkerAutoReload();

// Global error listeners → log to Supabase
window.addEventListener('error', (event) => {
  logError({ type: 'global_error', error: event.error ?? event.message });
});
window.addEventListener('unhandledrejection', (event) => {
  logError({ type: 'unhandled_rejection', error: event.reason });
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Suspense fallback={<div className="min-h-dvh flex items-center justify-center bg-black"><div className="w-12 h-12 border-4 border-white/5 border-t-teal rounded-full animate-spin"></div></div>}>
      <App />
    </Suspense>
  </StrictMode>,
)
